<template>
  <van-image
    :class="loading ? 'c-image-loading' : ''"
    v-bind="$attrs"
    v-on="$listeners"
    @load="loading = false"
  >
    <div v-if="$slots.default"><slot/></div>
    <template v-slot:loading>
      <img :src="loadingSrc" alt="" />
    </template>
    <template v-slot:error>
      <img :src="loadingSrc" alt="" />
    </template>
  </van-image>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      loadingSrc:
        this.$theme.u_goods_icon_default || require('@/assets/loadingBG.png')
    };
  }
};
</script>
